import { SelectorRowDecorativeElementTypeEnum } from '../../../../../../components/selectorRowV2/types/decorativeElement';
import { SelectorRowStates } from '../../../../../../components/selectorRowV2/types/state';
import { TextVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { SelectorRowVariants } from '../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => ({
    [SelectorRowVariants.REGULAR]: {
        [SelectorRowStates.UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_200,
                },
            }),
        },
        [SelectorRowStates.SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                },
            }),
        },
        [SelectorRowStates.HOVER]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_hover_primary_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                },
            }),
        },
        [SelectorRowStates.PRESSED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                },
            }),
        },
        [SelectorRowStates.FILLING]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                },
                label: {
                    // ! The font styles will be mixed between 200 and 250
                    font_variant: TextVariantType.FONT_PARAGRAPH_200,
                },
            }),
        },
        // In Design, this variant only has a general disabled style
        [SelectorRowStates.DISABLED_UNSELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_200,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                decorativeElement: {
                    [SelectorRowDecorativeElementTypeEnum.ICON]: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
        [SelectorRowStates.DISABLED_SELECTED]: {
            ...commonStyles(FOUNDATIONS, {
                rootContainer: {
                    cursor: 'auto',
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                },
                label: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_200,
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                decorativeElement: {
                    [SelectorRowDecorativeElementTypeEnum.ICON]: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
    },
});
//# sourceMappingURL=regular.js.map